import { RequestStatus } from 'features/request/requestSlice';
import type { CatalogUerBaseCostWorkScopeUpdateInput, CollectionUerBaseCostWorkScopeUpdateInput } from 'gql/graphql';

import type { GridApi } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';

import type { IRowWithCommonOptions } from '../types';

export type TUseUpdatePriceWorkScope = (onSuccess: () => void) => {
    request: (
        props: Partial<{
            inputs: CollectionUerBaseCostWorkScopeUpdateInput[] | CatalogUerBaseCostWorkScopeUpdateInput[];
        }>,
    ) => void;
    status: RequestStatus;
};

interface IUseUpdateWorkScope {
    api: GridApi<IRowWithCommonOptions> | undefined;
    onClose: () => void;
    onRefresh: () => void;
    useUpdate: TUseUpdatePriceWorkScope;
    useUpdateParams?: Partial<{}>;
}

export const useUpdateWorkScope = (props: IUseUpdateWorkScope) => {
    const { api, onClose, onRefresh, useUpdate, useUpdateParams = {} } = props;

    const onSuccessUpdate = useCallback(() => {
        onClose();
        onRefresh();
    }, [onClose, onRefresh]);

    const { request, status } = useUpdate(onSuccessUpdate);

    const isUpdating = useMemo(() => status === RequestStatus.FETCHING, [status]);

    const handleUpdate = useCallback(() => {
        const updateInputArr: CollectionUerBaseCostWorkScopeUpdateInput[] = [];

        api?.forEachNode((node) => {
            updateInputArr.push({
                name: node?.data?.name ?? '',
            });
        });

        request({
            ...useUpdateParams,
            inputs: updateInputArr,
        });
    }, [api, request, useUpdateParams]);

    return {
        isUpdating,
        handleUpdate,
    };
};
